import { createAction, props } from '@ngrx/store';

import { EndUsersGetResponse } from '../../typings/end-users';
import { MobileUsersGetResponse, MobileUsersPatchRequest, MobileUsersPatchResponse } from '../../typings/mobile-users';

export const registerMobileUser = createAction(
  '[User] Register Mobile User',
  props<{
    payload: {
      data: {
        company: string;
        email: string;
        firstName: string;
        lastName: string;
        phone: string;
      };
      isOnboardingFlow: boolean;
    };
  }>()
);

export const registerMobileUserSuccess = createAction(
  '[User] Register Mobile User Success',
  props<{
    payload: {
      id: string;
      isOnboardingFlow: boolean;
    };
  }>()
);

export const registerMobileUserFailure = createAction(
  '[User] Register Mobile User Error',
  props<{ payload: { error: Error } }>()
);

export const loadMobileUserSuccess = createAction(
  '[User] Load Mobile User Success',
  props<{ payload: { data: MobileUsersGetResponse; id: string } }>()
);

export const loadMobileUserFailure = createAction(
  '[User] Load Mobile User Failure',
  props<{ payload: { error: Error } }>()
);

export const loadEndUserDetails = createAction(
  '[User] Load End User Details',
  props<{ payload: { referralCode: string } }>()
);

export const loadEndUserDetailsSuccess = createAction(
  '[User] Load End User Details Success',
  props<{ payload: EndUsersGetResponse }>()
);

export const loadEndUserDetailsFailure = createAction(
  '[User] Load End User Details Error',
  props<{ payload: { error: Error } }>()
);

export const updateMobileUser = createAction(
  '[User] Update Mobile User',
  props<{
    payload: MobileUsersPatchRequest;
  }>()
);

export const updateMobileUserSuccess = createAction(
  '[User] Update Mobile User Success',
  props<{ payload: { data: MobileUsersPatchResponse; id: string } }>()
);

export const updateMobileUserFailure = createAction(
  '[User] Update Mobile User Error',
  props<{ payload: { error: Error } }>()
);

export const reloadMobileUser = createAction('[User] Reload Mobile User');

export const deleteData = createAction('[User] Delete Mobile User Data');

export const deleteDataFailure = createAction(
  '[User] Delete Mobile User Data Failure',
  props<{ payload: { error: Error } }>()
);
